export default function getDocument() {
  return document;
}